import React from "react";

import { Box, Typography } from "@mui/material";

import { LucideMaximize2 } from "lucide-react";

import { ListCard } from "@/components/Luna/features";
import useLesson from "@/contexts/useLesson";
import { Diagram } from "@/types";

interface DiagramItemProps {
  diagram: Diagram;
  index: number;
  onOpenModal: (diagram: Diagram) => void;
}

const DiagramItem: React.FC<DiagramItemProps> = ({
  diagram,
  index,
  onOpenModal,
}) => {
  const { lessonResourceState } = useLesson();
  const isRead = lessonResourceState?.readItems.includes(diagram.id);

  return (
    <ListCard
      title={`${index + 1}. ${diagram.title}`}
      isApproved={diagram.isApproved}
      onApprove={() => {}}
      onRegenerate={() => {}}
      index={index}
      onOpenModal={() => onOpenModal(diagram)}
      id={diagram.id}
      isRead={isRead}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        mt={1}
        onClick={(e) => {
          e.stopPropagation();
          onOpenModal(diagram);
        }}
      >
        {diagram.description.substring(0, 250)}
        {diagram.description.length > 250 ? (
          <span className="text-gray-500">...</span>
        ) : (
          ""
        )}
      </Typography>
      <Box sx={{
 position: "relative",
mt: 2 
}}>
        <img
          src={diagram.imageUrl}
          alt={diagram.title}
          style={{
 width: "100%",
height: "auto" 
}}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            opacity: 0,
            "&:hover": { opacity: 0.4 },
            transition: "opacity 0.3s",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => onOpenModal(diagram)}
        >
          <LucideMaximize2 width={24} height={24} style={{ color: "white" }} />
        </Box>
      </Box>
    </ListCard>
  );
};

export default DiagramItem;
